import { render, staticRenderFns } from "./TheCatalogTitlePage.vue?vue&type=template&id=0c1f370e&"
import script from "./TheCatalogTitlePage.vue?vue&type=script&lang=js&"
export * from "./TheCatalogTitlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports